import { Text } from "@react-three/drei"
import { useFrame } from "@react-three/fiber"
import { useRef } from "react"
import { AdditiveBlending } from "three"
import { useIsMobile } from "../../../utils/useIsMobile"

export default function TextThree() {
    const isMobile = useIsMobile()
    const mainRef = useRef()

    const content = `UI UX\nFRONT END\nCREATIVE DEV`

    useFrame(({ clock }) => {
        const t = clock.getElapsedTime()
        if (mainRef.current) {
            mainRef.current.position.y = Math.sin(t * 3.0) * 0.01
            mainRef.current.rotation.z = Math.sin(t * 2.0) * 0.02
        }
    })

    const common = {
        font: "font/Mattone-Bold.woff",
        fontSize: isMobile ? 0.3 : 0.6,
        anchorX: "center",
        anchorY: "middle",
        frustumCulled: false,
    }

    const depthSafe = { toneMapped: false }

    return (
        <group
            position={isMobile ? [-0.22, -3, 7] : [-2.8, -2.1, 5]}
            rotation={isMobile ? [0, Math.PI * 0.3, 0] : [0, Math.PI * 0.45, -0.1]}
        >
            {/* SHADOW unique */}
            <Text
                {...common}
                position={[0.12, -0.10, -0.12]}
                color="#0b0b0b"
                renderOrder={1}
            >
                {content}
                <meshBasicMaterial {...depthSafe} depthWrite={false} />
            </Text>

            <Text
                {...common}
                position={[-0.012, 0.0, 0.045]}
                color="#ff2bd6"
                renderOrder={2}
            >
                {content}
                <meshBasicMaterial
                    {...depthSafe}
                    transparent
                    opacity={0.55}
                    blending={AdditiveBlending}
                    depthTest={false}
                    depthWrite={false}
                />
            </Text>

            <Text
                {...common}
                position={[0.012, 0.0, 0.045]}   // opposé à la magenta
                color="#00e5ff"
                renderOrder={2.1}
            >
                {content}
                <meshBasicMaterial
                    {...depthSafe}
                    transparent
                    opacity={0.55}
                    blending={AdditiveBlending}
                    depthTest={false}
                    depthWrite={false}
                />
            </Text>

            {/* TEXTE PRINCIPAL (stroke natif + shader) */}
            <Text
                ref={mainRef}
                {...common}
                position={[0, 0, 0.06]}
                strokeWidth={isMobile ? 0.01 : 0.02}
                strokeColor="#6b0464"
                renderOrder={3}
            >
                {content}
                <shaderMaterial
                    attach="material"
                    transparent={false}
                    depthTest={false}
                    depthWrite={false}
                    toneMapped={false}
                    vertexShader={`
                        varying vec2 vUv;
                        void main() {
                          vUv = uv;
                          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
                        }
                    `}
                    fragmentShader={`
                        varying vec2 vUv;

                        float circle(vec2 uv, vec2 center, float radius) {
                          return smoothstep(radius, radius - 0.01, length(uv - center));
                        }

                        void main() {
                          vec3 top = vec3(1.0, 0.95, 0.25);
                          vec3 mid = vec3(1.0, 0.35, 0.10);
                          vec3 bot = vec3(0.85, 0.05, 0.05);

                          float y = clamp(vUv.y, 0.0, 1.0);
                          vec3 base = mix(bot, mid, smoothstep(0.0, 0.5, y));
                          base = mix(base, top, smoothstep(0.4, 1.0, y));

                          float bottomMask = smoothstep(0.55, 0.15, y);

                          float scale = 70.0;
                          vec2 gridUv = fract(vUv * scale);

                          float dot = circle(gridUv, vec2(0.5), 0.25);

                          vec3 dotColor = vec3(0.6, 0.0, 0.0);

                          vec3 finalColor = mix(base, dotColor, dot * bottomMask);
                          gl_FragColor = vec4(finalColor, 1.0);
                        }
                    `}
                />
            </Text>

            <Text
                {...common}
                position={isMobile ? [0, -1, -0.12] :[-1.85, -1.4, -0.12]}
                color="#ff00d0"
                strokeWidth={isMobile ? 0.01 : 0.005}
                strokeColor="#000000"
                renderOrder={4}
                fontSize={0.15}
                depthTest={false}
                depthWrite={false}
                toneMapped={false}
            >
                KEEP SCROLLING !
                <meshBasicMaterial {...depthSafe} depthWrite={false} />
            </Text>
        </group>
    )
}